import React from 'react';
import AnnotationImg from 'components/main/images/Annotation.png';
import ROIImg from 'components/main/images/ROI.png';
import DisableImg from 'components/main/images/DisabledImaging.png';
import HistogramImage from 'components/main/images/Histogram.png';
import ScribbleImg from 'Icon/Scribble.png';
import CrystalImg from 'components/main/images/Crystal.png';
export interface NavigatorDrawingsProps {
  annotationIcon: boolean;
  histogramIcon: boolean;
  roiIcon: boolean;
  disableImageIcon: boolean;
  scribbleIcon: boolean;
  crystalIcon: boolean;
}

const getIcon = (src: string) => {
  return (
    <img
      style={{ height: '3vh', objectFit: 'contain' }}
      src={src}
      alt="No Image"
    />
  );
};

const NavigatorDrawingIcons = (props: NavigatorDrawingsProps) => {
  const { annotationIcon, roiIcon, disableImageIcon, histogramIcon, scribbleIcon, crystalIcon } = props;
  return (
    <>
      {crystalIcon && getIcon(CrystalImg)}
      {roiIcon && getIcon(ROIImg)}
      {disableImageIcon && getIcon(DisableImg)}
      {annotationIcon && getIcon(AnnotationImg)}
      {scribbleIcon && getIcon(ScribbleImg)}
      {histogramIcon && getIcon(HistogramImage)}
    </>
  );
};
export default NavigatorDrawingIcons;
